module.exports = __webpack_public_path__ + "img/G_Art_Claw_R_1_1_3.3a278519.png";